import React from 'react';
import Avatar from '../../components/Avatar';
import { globalFormat } from '../../utils/formatting';
import KubitTooltip from '../../components/KubitTooltip';

interface IProps {
  label: string;
  picture?: string;
  createdAt?: string;
}

const FormCreator = ({ label, picture, createdAt }: IProps) => {
  const { dateFormat, timeFormat } = globalFormat.getGlobalFormat();

  return (
    <KubitTooltip
      content={
        createdAt
          ? `Created by: ${label}\nCreated Time: ${globalFormat.formatDate(
              createdAt,
              {
                dateFormat,
                timeFormat,
              },
            )}`
          : label
      }
      placement="bottom"
      noOpenDelay={true}
    >
      <Avatar picture={picture} size={20} />
    </KubitTooltip>
  );
};

export default FormCreator;
